export default __webpack_public_path__ + "static/media/Group-1203.b8214eeb.png";